import { apiClient } from './api.js';
import { unwrap } from './api-error.js';
import type { ApiPaths } from '@reos/api-client';

/**
 * Krok B1c bod 9 — zapis vysledku Nahlizeni do KN na jednotku.
 *
 * Typy chodi z vygenerovaneho OpenAPI klienta, ne z rucniho interface: tvar
 * tela i odpovedi drzi kontrakt API, ne domluva mezi dvema soubory.
 */

type Endpoint = ApiPaths['/v1/duediligence/cases/{id}/unit-cadastre']['post'];

export type UnitCadastreBody = NonNullable<Endpoint['requestBody']>['content']['application/json'];
export type UnitCadastreResult = Endpoint['responses']['201']['content']['application/json'];
export type UnitCadastreRule = UnitCadastreResult['rules'][number];

export async function saveUnitCadastre(
  caseId: string,
  body: UnitCadastreBody,
): Promise<UnitCadastreResult> {
  return unwrap(
    apiClient.POST('/v1/duediligence/cases/{id}/unit-cadastre', {
      params: { path: { id: caseId } },
      body,
    }),
  );
}
